// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mew-switch input {\n  pointer-events: all;\n}\n.mew-switch.v-input--is-label-active .v-input--switch__track {\n  color: var(--v-primary-base) !important;\n  caret-color: var(--v-primary-base) !important;\n  opacity: 1;\n}", ""]);
// Exports
module.exports = exports;
